<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Servis Plan</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/liste/servis/yonlendirilen"><button type="submit" class="btn submit bg-dark text-light">Geri Dön</button>
          </router-link>

          <button data-toggle="modal" data-backdrop="static" data-target=".bd-example-modal-lg" type="button" class="btn btn-outline-info ml-3">Servis Bilgileri</button>
          
          <button v-if="selectKullanici.length>0 && this.newpost.selectdepo!='000000'"  @click="onChange()" class="btn btn-outline-danger ml-3">Planla </button>

            <div class="modal fade bd-example-modal-lg " tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content bg-dark">
                  <div class="modal-body">
                    <div class="row">

                      <div class="col-6 text-center">
                        <div class="pie-chart chart block">
                          <strong>{{posts.cari_ad}}</strong>
                        </div>
                      </div>

                      <div class="col-3 text-center">
                        <div class="pie-chart chart block">
                          <strong> {{posts.ekipName}}</strong>
                        </div>
                      </div>

                      <div class="col-3 text-center">
                        <div class="pie-chart chart block">
                          <strong>No: : {{posts.no}}</strong>
                        </div>
                      </div>

                    </div>
                    <div class="row">
                        <div class="col-4 text-center">
                          <div class="pie-chart chart block">
                            <strong>Cihaz : {{posts.cname}}</strong>
                          </div>
                        </div>
                        <div class="col-4 text-center">
                          <div class="pie-chart chart block">
                            <strong>Model : {{posts.model}}</strong>
                          </div>                           
                        </div>
                        <div class="col-4 text-center">
                          <div class="pie-chart chart block">
                            <strong>{{posts.barkod}}</strong>
                          </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 text-center">
                          <div class="pie-chart chart block">
                            <strong>Servis Nedeni : {{posts.sn}}</strong>
                          </div>
                        </div>
                        <div class="col-6 text-center">
                          <div class="pie-chart chart block">
                            <strong class="dashtext-3">Servis Öncelik : {{posts.so}}</strong>
                          </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 text-center">
                          <div class="pie-chart chart block">
                            <strong>Servis Tarihi : {{$helper.trtgoster(posts.ptarih)}}</strong>
                          </div>
                        </div>
                        <div class="col-6 text-center">
                          <div class="pie-chart chart block">
                            <strong>Servis Saati : {{posts.psaat}}</strong>
                          </div>
                        </div>
                    </div>
                    <div class="row"> 
                      <div class="col-12">
                       <div class="pie-chart chart block">Bilgi : {{posts.notu}}</div>
                      </div>
                    </div>
                  </div> 
                    <div class="modal-footer">
                      <button type="button" data-dismiss="modal" class="btn btn-outline-primary">Kapat</button>
                    </div>
                </div>
              </div>
            </div>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-2 col-12">
            <div class="row">
              <div class="col-12">
               <div class="messages-block block">
                  <div class="title"><strong>{{posts.bolge}} Ekipleri</strong></div>
                  <div class="messages">
                    <a @click="personel(postu.alias,postu.id)" v-for="(postu,index) in ekip" :key="index" class="message d-flex align-items-center mb-4 p-0">
                     <div class="profile text-center p-2" style="border:2px solid #319db2; font-size:18px; font-weight:bold; color:white; border-radius:100%">{{index+1}}</div>
                      <div class="content"><strong class="d-block">{{postu.alias}}</strong>
                      <span class="d-block">{{postu.kodu}}</span>
                      </div>
                    </a>
                  </div>
                </div>
               </div>
            </div>
            <div class="row">
                            <div class="col-12">
               <div class="messages-block block">
                  <div class="title"><strong>Önerilen Ekip</strong></div>
               </div>
                            </div>
            </div>
          </div>
          <div class="col-lg-10 col-12">
            <div class="row">
                <div class="col-5">
                  <div class="row">
                    <div class="col-12">
             <!--           <div class="title"><strong>{{newpost.ekip}} Personelleri</strong></div> -->
                          <div class="public-user-block block" style="margin-bottom:2px"  v-for="(postu,index) in kullanici" :key="index" >
                            <div class="row d-flex align-items-center pt-0">                   
                              <div :class="{ 'selected': isChecked(postu.kid)}"  @click="filter(postu.isim,postu.kid)" class="col-lg-8 d-flex align-items-center pl-1">
                                <div class="avatar" style="margin-left:0"> <img src="/set/img/avatar-6.jpg" class="img-fluid"></div>
                                <div class="name"><strong class="d-block">{{postu.isim}}</strong>
                                    <span class="d-block">{{postu.tip}}</span>
                                </div>
                              </div>
                              <div class="col-lg-3">
                                <div class="details d-flex">
                                  <div class="item mr-2"><i class="icon-info" ></i><strong>{{postu.adet}}</strong></div>
                                  <div class="item ml-2"><i class="icon-dashboard"></i><strong>{{postu.adet2}}</strong></div>
                                </div>
                              </div>
                              <div class="col-lg-1"><div class="mt-2"> <i @click="bak(postu.kid)" class="fa fa-trash fa-lg"></i></div></div>
                            </div>
                          </div>
                    </div>
                  </div>
                </div>

                <div class="col-7">
                  <div class="row">
                    <div class="col-5">
                      <div class="pie-chart chart block">
                        <label class="form-control-label">Servis Tarihi</label>
                        <input type="date" v-model="newpost.ptarih" class="form-control">
                      </div>
                    </div>
                    <div class="col-3">
                      <div class="pie-chart chart block">
                        <label class="form-control-label">Servis Saati</label>
                        <input type="time" v-model="newpost.psaat" class="form-control">
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="pie-chart chart block">
                        <label class="form-control-label">Depo Seçimi</label>
                         <select @change="deposec($event)" class="form-control">
                         <option selected value="000000">Depo</option>
                         <option v-for="(depos,index) in depo" :key="index" 
                         :value="depos.dep_no+'#'+depos.dep_adi">{{depos.dep_adi}}</option>
                      </select>
                      </div>
                    </div>
                  </div>
                  <div v-if="newpost.selectdepo !='000000'" class="row">
                    <div class="col-12">
                      <div class="pie-chart chart block">
                          <div class="i-checks">
                            <input type="checkbox" v-model="newpost.depokilit" class="checkbox-template">
                            <label for="checkboxCustom">Bu Servisde Ekip Lideri Depoyu değiştiremez</label>
                          </div>
                      </div>    
                    </div>
                  </div>
                    <div class="row">
                      <div class="col-12">
                        <div class="block margin-bottom-sm">
                          <div class="table-responsive">
                            <table id="tablo" class="table table-striped">
                                <thead>
                                  <tr>
                                    <th>No</th>
                                    <th>Müşteri</th>
                                    <th>Tarih</th>
                                    <th>Saat</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="post in filteredItems(servis,'isim')" :key="post.sid">
                                    <td class="dashtext-3">{{post.no}}</td>
                                    <td>{{post.cari_ad}}</td>
                                    <td>{{$helper.trtgoster(post.ptarih)}}</td>
                                    <td>{{post.psaat}}</td>
                                  </tr>
                                </tbody>
                              </table>
                          </div>
                        </div>
                      </div>
                      </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
<div v-if="progres.inprogres" class="loading"><img src="/set/ajax-loader.gif"/></div>   
  </div>
</template>

<script>
import { decode } from 'js-base64';
export default {
   created() {
     this.progres.inprogres = true
     this.yetki();
  },
  data () {
    return {
      posts :{},
      ekip:[],
      depo:[],
      error :[],
      kullanici :[],
      fid:'',
      said:'',
      bid:'',
      url : this.$route.params.id,
      selectKullanici:[],
      donem : this.$request.donem(),
      newpost:{
        id : '',
        ptarih:'',
        psaat:'',
        selectdepo:'000000',
        depokilit:false,
        ekipid:'',
        ekip:''
      },
      name:'',
      servis:[],
      currentTag: 'Erhan',
      ayar:this.$request.ayar(),
      progres : {
        mesaj:'Bekleyiniz',
        inprogres:false
      },
      kisa:decode(this.$request.ayar().genel.s),

    }
  },
    methods : {

        isChecked(value) { //renklendirme işlemi
          return this.selectKullanici.includes(value)
        },
        bak(indexi){
          const index = this.selectKullanici.indexOf(indexi);
            if (index > -1) {
              this.selectKullanici.splice(index, 1);
            }
        },
        onChange() {

            this.$swal({
              title: 'Onaylıyor musunuz?',
              text: 'Sevisi Planlıyorum...',
              type: 'warning',
              //showCancelButton: true,
              confirmButtonText: 'Evet',
              showCloseButton: true,
              showLoaderOnConfirm: true
            }).then((result) => {
              if(result.value) {
                this.progres.inprogres = true
                  this.$request.post("planlama/",this.newpost)
                  .then(res => {
                      let log ={
                        servis_id : res.data.id,
                        tarih: new Date(),
                        saat :this.$helper.trsaatyazdir(),
                        sd:2,
                        kid:this.ayar.kid,
                        islem: 'Servis Planlandı'
                      }
                      this.$request.post("servis_log/",log)
                        .then(res => {
                            if (!res.error) {
                              this.userdelete(log.servis_id)
                            }
                        })
                  })
              }
            })
        },
        userdelete : function(id){
          this.$request.get("userservisyetki/"+id)
          .then(res => {
               if (!res.error) {
                              this.userEkle(id)
                            }
          })
        },
        userEkle : function(id){
          setTimeout (()=>{
              for (let i = 0; i < this.selectKullanici.length; i++) { 
                  let user = {
                    valuesi:id,
                    kid:this.selectKullanici[i],
                    keysi:'sid_',
                    table:'servis_yetki'
                  }
                  this.$request.post("userservisyetki/",user)
                  .then(res => {
                        this.progres.inprogres = false
                        this.$swal("Servis Plandı")
                  })
              }},2000)
              this.getPostsAsync(this.newpost.id)
        },      

        yetki: function(){

          if (this.$helper.sayfayetki(592766)){
            let res = this.url.split('sd');

            let sol = res[0].split('bn');
            this.fid = sol[0]/8848;
            this.said = sol[1]/8847;

            let sag = res[1].split('bn');
            this.bid = sag[0]/8846;
            this.newpost.id = sag[1]/8589;

            let baslat = false;
              let table ='';
                if (this.ayar.ya=='sid'){
                    table = 'kayit' // servis personeli buraya giremez
                    baslat = true
                    this.getPostsAsync(this.newpost.id,table,baslat)
                }
                else{
                    table = 'kayit'
                    baslat=true
                    this.getPostsAsync(this.newpost.id,table,baslat)
                }
              }
          else {
            alert('Bu alanı kullanım yetkiniz yok')
            this.$router.go(-1)
          }
      },
        getPostsAsync (sid,table,baslat){
          if (baslat){
            this.$request.get("detay/servis/"+this.ayar.ya+"/"+this.ayar.kid+'/'+sid+'/'+table) 
              .then(res => {
                 this.posts=res.servis
                  if (!res.error){this.servisler()} 
                })
              .catch(err => {this.error.push(err)})
          }
        },
            servisler: function(){
              this.servis = []
              this.$request.get("servisler/"+this.bid)
               .then(res => { this.servis = res.results 
                    this.ekipler()
               })
            },
            ekipler(){
              //this.ekip = []
                this.$request.get("ekip/"+this.bid)
                .then(res => {  this.ekip = res.results
                  this.progres.inprogres = false
                  this.depogetir()
                 })
                .catch(err => this.error.push(err))
            },

            // depogetir(){
            //   this.$request.get("depo/"+this.ayar.firmaid)
            //   .then(res => {this.depo = res.results;this.progres.inprogres = false})
            // },

            depogetir(){ // mikro depo bağlantı
              this.$request.get("depoliste/"+this.kisa)
              .then(res => {this.depo = res;this.progres.inprogres = false})
            },
            deposec(value){
             this.newpost.selectdepo = event.target.value
              if (event.target.value === '000000'){this.newpost.depokilit = false}
            },

            // sadece ekiplerdeki personelleri döker
            personel(tagi,id){
              this.newpost.ekipid = id;
              this.newpost.ekip = tagi;
              this.kullanici = []
                this.$request.get("kullanici/"+this.ayar.firmaid+"/"+id+"/"+this.bid) // buradaki id ekipid
                .then(res => {
                                for (let i = 0; i < res.results.length; i++) {
                                  let kullanici = {
                                      kid:res.results[i].kid,
                                      tip:res.results[i].tip,
                                      isim:res.results[i].isim,
                                      adet:this.groupByEkip(res.results[i].kid,2),
                                      adet2:this.groupByEkip(res.results[i].kid,3)
                                }
                              this.kullanici.push(kullanici)
                                   this.progres.inprogres = false
                                  }
                })
                .catch(err => this.error.push(err))

            },
            groupByEkip (id,sd){
              let count = 0;
              //let arr = new array(this.servis)
              for (let i = 0; i < this.servis.length; i++) {
                  if (this.servis[i].kid_===id && this.servis[i].sdid===sd){count +=+1}
              }
              return count
            } ,

            filter: function(isim,kid) {
              const index = this.selectKullanici.indexOf(kid);
              if (index === -1) {this.selectKullanici.push(kid)}
              this.currentTag = isim;
            },
            
            filteredItems: function(array,field) {
              var filter = this.currentTag;
              if (filter == 'All' ){
                  return array
              }
              else{
                    return array.filter(function(item) {
                    return item[field].indexOf(filter) !== -1;
              });
              }
            }        
     }
   }
</script>
<style scoped>
.selected{
color:#aa3e4b
}
</style>



// WEBPACK FOOTER //
// src/views/servis/plan.vue